import SEO from '../../components/common/SEO/SEO';
import SmeadITWidget from '../../components/common/SmeadITWidget';
import './ReportBug.css';

const ReportBug = () => (
  <>
    <SEO
      title="Report a Bug | KO Holistic Health"
      description="Found something broken on the KO Holistic Health website? Let us know and we'll fix it."
      noindex
    />
    <div className="report-bug-page">
      <div className="report-bug-page__hero">
        <div className="container">
          <h1>Report a Bug</h1>
          <p className="report-bug-page__subtitle">
            Found something not working as expected? Let us know — we appreciate your help.
          </p>
        </div>
      </div>

      <div className="report-bug-page__content">
        <div className="container">
          <div className="report-bug-page__card">
            <SmeadITWidget />
          </div>
        </div>
      </div>
    </div>
  </>
);

export default ReportBug;
